module.exports = __webpack_public_path__ + "1_0_59/img/tasks_chat_back.6355777f.svg";